import { OperatorFunction } from 'rxjs';
import { map } from 'rxjs/operators';
import { MapHlp } from 'src/lib/fliko/helpers/map.helper';
import { SetHlp } from 'src/lib/fliko/helpers/set.helper';
import { KeyOf } from 'src/lib/fliko/types/nestedKey.type';

/**
 * Create map from object list by key
 * @param {NestedKeyOfObj} key , default 'id'
 * @return {Map<string, T>}
 */
export function idMap<T>(key?: KeyOf<T>): OperatorFunction<T[] | null | undefined, Map<string, T>> {
  return map((x) => MapHlp.idMap(x ?? [], key ?? ('id' as any)));
}

export function idSet(key: string = 'id'): OperatorFunction<any[] | null | undefined, Set<string>> {
  return map((x) => SetHlp.idSet(x ?? [], key));
}

export function idMapArray<T>(keys?: KeyOf<T>[]): OperatorFunction<T[] | null | undefined, Map<string, T[]>> {
  return map((x) => MapHlp.idMapArray(x ?? [], keys ?? (['id'] as any[])));
}
